import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Globe } from "lucide-react";
import { cn } from "../lib/utils";

export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
  ];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
  };

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];

  // Detectar si estamos en un fondo oscuro (patrol login)
  const isDarkBackground = typeof window !== 'undefined' && (
    window.location.pathname.includes('/patrol/login') || 
    document.body.classList.contains('dark') ||
    document.querySelector('.bg-slate-900')
  );

  return (
    <div className="flex items-center gap-3">
      <Globe className={cn(
        "h-5 w-5",
        isDarkBackground ? "text-orange-400" : "text-slate-600"
      )} />
      <Select value={i18n.language} onValueChange={handleLanguageChange}>
        <SelectTrigger className={cn(
          "w-[170px] h-10",
          isDarkBackground 
            ? "bg-slate-700 border-2 border-orange-500/60 text-white hover:bg-slate-600 hover:border-orange-500 focus:border-orange-500 shadow-lg" 
            : "border-slate-300"
        )}>
          <SelectValue>
            <span className="flex items-center gap-2">
              <span className="text-lg">{currentLanguage.flag}</span>
              <span className={cn(isDarkBackground ? "text-white font-semibold" : "")}>{currentLanguage.name}</span>
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

